import { useEffect, useState } from "react";
import { Flex, VStack } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import CDS from "design-system";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
`;

interface ProgressMessagesProps {
  messages: string[];
  subtitle?: string;
  intervalMs?: number;
}

export default function ProgressMessages({
  messages,
  subtitle = "This can take a moment, please sit tight",
  intervalMs = 3500,
}: ProgressMessagesProps) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // Add some variance to the interval (+/- 500ms)
    const jitteredInterval = intervalMs + Math.floor(Math.random() * 1000) - 500;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % messages.length);
    }, jitteredInterval);

    return () => clearInterval(timer);
  }, [intervalMs, messages.length]);

  return (
    <Flex justify="center" align="center" minH="200px">
      <VStack spacing={3}>
        <Flex w="48px" h="48px" align="center" justify="center" borderRadius="full" bg="brand.50">
          <Flex
            w="24px"
            h="24px"
            borderRadius="full"
            border="3px solid"
            borderColor="brand.500"
            borderTopColor="transparent"
            animation="spin 0.8s linear infinite"
            sx={{
              "@keyframes spin": {
                from: { transform: "rotate(0deg)" },
                to: { transform: "rotate(360deg)" },
              },
            }}
          />
        </Flex>
        <CDS.Text14 key={index} color="gray.600" fontWeight="medium" textAlign="center" animation={`${fadeIn} 0.3s ease-out`}>
          {messages[index]}
        </CDS.Text14>
        {subtitle && (
          <CDS.Text12 color="gray.400">
            {subtitle}
          </CDS.Text12>
        )}
      </VStack>
    </Flex>
  );
}
